var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"txt-bg"},[_c('p',{staticClass:"txt-bg-d"},[_vm._v("DAVICH")]),_c('p',{staticClass:"txt-bg-h"},[_vm._v(_vm._s(this.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }